<script>
export default {
  name: 'Grid',
}
</script>

<script setup>
import { NodeViewWrapper, nodeViewProps, NodeViewContent } from "@tiptap/vue-3"
import EditableNode from "../../Components/EditableNodeWrapper.vue"
import useNodeProps from "@/Composables/useNodeProps"

// Tools
import EditGrid from "@/Components/Inputs/BlockEditor/Extension/Modals/EditGrid.vue"

const props = defineProps({
  ...nodeViewProps,
})

let { cols, spacing, mobileCols } = useNodeProps(props)
</script>

<template>
  <node-view-wrapper>
    <EditableNode v-bind="props">
      <template #tools>
        <EditGrid
          v-model:cols="cols"
          v-model:spacing="spacing"
          v-model:mobileCols="mobileCols"
        />
      </template>
      <template #content>
        <node-view-content :class="['grid divide-x divide-gray-100 w-full p-2', 'grid-cols-' + mobileCols, 'md:grid-cols-' + cols, 'gap-' + spacing]"></node-view-content>
      </template>
    </EditableNode>
  </node-view-wrapper>
</template>
